import React from 'react';
import './styles.scss';
import '../styles.scss';
import RightArrow from './right-arrow.svg';
import { useStaticQuery, graphql } from "gatsby"
import Img from 'gatsby-image';
import { Icons } from '@hyperping/design';
import { buildRegisterUrl } from '../../../utils';

const Star = () => (<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="#eece6e" stroke="#eece6e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>);

const CustomerReview = () => (<div className="flex align-items-center font-size-13px font-weight-400 gap-035em margin-auto width-fit-content mt-2em mb-1em" style={{color: '#AEB2B7'}}>
  <div className="flex" style={{gap:'3px'}}><Star/><Star/><Star/><Star/><Star/></div>
  <div className="font-weight-300">Trusted by 300+ fast-growing startups & DevOps teams</div>
</div>);

const FreePack = () => (<div className="flex align-items-center font-size-13px font-weight-400 text-align-left gap-2em" style={{color: '#AEB2B7',height:'50px'}}>
  <div className="flex gap-075em flex-direction-column" style={{ flex: '1 1 50%' }}>
    <div className="flex align-items-center gap-035em font-weight-300" style={{ whiteSpace: 'nowrap' }}><Icons name="megaphone"/> 1 free status page</div>
    <div className="flex align-items-center gap-035em font-weight-300" style={{ whiteSpace: 'nowrap' }}><Icons name="globe"/> 5 free monitors</div>
  </div>
  <div className="flex gap-075em flex-direction-column" style={{ flex: '1 1 50%' }}>
    <div className="flex align-items-center gap-035em font-weight-300" style={{ whiteSpace: 'nowrap' }}><Icons name="clock"/> 14-day trial for advanced features</div>
    <div className="flex align-items-center gap-035em font-weight-300" style={{ whiteSpace: 'nowrap' }}><Icons name="creditcard"/> No credit card required</div>
  </div>
</div>);

const getCatchPhrase = (isBrowser) => {
  if (isBrowser) {
    return (<>
    <h1 className="fadeInDown">Automate Performance and Reliability Testing</h1>
    <h2 className="sub-line">Use Puppeteer & Playwright to periodically perform end-2-end monitoring.</h2>
  </>);
  } else {
    return (<>
      <h1 className="flex justify-content-center align-items-center">Show uptime.<br/>Catch downtime.</h1>
      <h2 className="sub-line font-weight-300">Stay ahead with fast, reliable monitoring and beautiful status pages—all without breaking the bank.</h2>
    </>)
  }
}

const Hero = ({ isBrowser = false }) => {
  const data = useStaticQuery(graphql`
    query {
      image1: file(relativePath: { eq: "hero5.webp" }) {
        childImageSharp {
          fluid(maxWidth: 1160, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      
      image2: file(relativePath: { eq: "browser.png" }) {
        childImageSharp {
          fluid(maxWidth: 1160, quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);

  return (
    <section className="home-top relative">
      {/* <img className="absolute bg-hero-pattern" src={BgHero} loading="eager" alt="" aria-hidden="true"></img> */}
      <div className="home-top-content">
        {getCatchPhrase(isBrowser)}
        <div className="cta-content gap-1em">
          <div className="signup-content">
          <a className="sign-up-google plausible-event-name=Signup+attempt" href="/oauth-google">
            <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjQuMDIgMTIuMjcyMkMyNC4wMiAxMS40MjEzIDIzLjk0MzYgMTAuNjAzMSAyMy44MDE4IDkuODE3NjNIMTIuNVYxNC40NTk0SDE4Ljk1ODJDMTguNjggMTUuOTU5NSAxNy44MzQ1IDE3LjIzMDQgMTYuNTYzNiAxOC4wODEzVjIxLjA5MjJIMjAuNDQxOEMyMi43MTA5IDE5LjAwMzEgMjQuMDIgMTUuOTI2NyAyNC4wMiAxMi4yNzIyWiIgZmlsbD0iIzQyODVGNCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjUgMjMuOTk5M0MxNS43NCAyMy45OTkzIDE4LjQ1NjQgMjIuOTI0OCAyMC40NDE4IDIxLjA5MkwxNi41NjM3IDE4LjA4MTFDMTUuNDg5MSAxOC44MDExIDE0LjExNDYgMTkuMjI2NiAxMi41IDE5LjIyNjZDOS4zNzQ1NiAxOS4yMjY2IDYuNzI5MSAxNy4xMTU3IDUuNzg1NDYgMTQuMjc5M0gxLjc3NjM3VjE3LjM4ODRDMy43NTA5MSAyMS4zMTAyIDcuODA5MSAyMy45OTkzIDEyLjUgMjMuOTk5M1oiIGZpbGw9IiMzNEE4NTMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01Ljc4NTQ1IDE0LjI4MTRDNS41NDU0NSAxMy41NjE0IDUuNDA5MDkgMTIuNzkyMyA1LjQwOTA5IDEyLjAwMTRDNS40MDkwOSAxMS4yMTA1IDUuNTQ1NDUgMTAuNDQxNCA1Ljc4NTQ1IDkuNzIxNFY2LjYxMjNIMS43NzYzNkMwLjk2MzYzNiA4LjIzMjMgMC41IDEwLjA2NSAwLjUgMTIuMDAxNEMwLjUgMTMuOTM3OCAwLjk2MzYzNiAxNS43NzA1IDEuNzc2MzYgMTcuMzkwNUw1Ljc4NTQ1IDE0LjI4MTRaIiBmaWxsPSIjRkJCQzA1Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuNSA0Ljc3MjczQzE0LjI2MTggNC43NzI3MyAxNS44NDM2IDUuMzc4MTggMTcuMDg3MyA2LjU2NzI3TDIwLjUyOTEgMy4xMjU0NUMxOC40NTA5IDEuMTg5MDkgMTUuNzM0NiAwIDEyLjUgMEM3LjgwOTEgMCAzLjc1MDkxIDIuNjg5MDkgMS43NzYzNyA2LjYxMDkxTDUuNzg1NDYgOS43MkM2LjcyOTA5IDYuODgzNjQgOS4zNzQ1NSA0Ljc3MjczIDEyLjUgNC43NzI3M1oiIGZpbGw9IiNFQTQzMzUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K" alt="Google" width="20" />
            Sign-up for free
          </a>
            <a className="or-via-email plausible-event-name=Signup+attempt" href={buildRegisterUrl()} target="_blank">Or sign up via email <img src={RightArrow} /></a>
          </div>
          {/* <a className="button-cta" href="https://meta.hyperping.app" target="_blank">Status page demo</a> */}

          <div className="flex flex-direction-column gap-1em">
            <FreePack />
          </div>
        </div>
        <CustomerReview />
        <Img width="1160" fluid={data[isBrowser ? 'image2' : 'image1'].childImageSharp.fluid} />
        {/* <Img width="400" fluid={data['image3'].childImageSharp.fluid} /> */}
        {/* <img src={Dashboard} /> */}
      </div>
    </section>
  );
};

export default Hero;
